import ja from "./ja";
import ja_kanji from "./ja_kanji";

export const I18nTranslations = {
  ja: ja,
  ja_kanji: ja_kanji,
};
